import React from "react";

import ToggleButton from "./ToggleButton.tsx";
import { FaUndo } from "react-icons/fa";

// For backward compatibility - this maintains the original component API
interface WordButtonProps {
  isKnown: boolean;
  isDeleted: boolean;
  onClick: () => void;
}

const AddWordButton: React.FC<WordButtonProps> = ({
  isKnown,
  isDeleted,
  onClick,
}) => {
  const inactiveText = isDeleted ? "Undelete" : "Add to Known";
  const inactiveIcon = isDeleted ? <FaUndo className="w-3 h-3" /> : undefined;
  return (
    <ToggleButton
      isActive={isKnown}
      activeText="Added to Known"
      inactiveText={inactiveText}
      inactiveIcon={inactiveIcon}
      onClick={onClick}
    />
  );
};

export default AddWordButton;
